import React, { useEffect, useState } from 'react';
import FileSelection from './file-selection';
import DifferenceSelection from './difference-selection';
import { Button, Grid } from '@mui/material';
import { 
    getDiffCalculation, getChartAttributes, 
    getFiles, getMergeAttributes
} from '../../api/files';
import FileExplorer from './file-explorer';
import { LoadingDialog } from '@kepler.gl/components';

//TODO: - update files ui tree list on file explorer when file is uploaded
//TODO: Uploading file state handling on UI e.g. is loading, is processing etc
//TODO: Refactor API calls to submodule

import { findConfigFiles } from './file-utils';
import { FILE_EXPLORER_OPTIONS, UPLOAD_STATUS } from './constants';
import OptionSelect from './option-select';
import ChartSelect from './chart-select';

const LoadFileContainer = (props) => {
    const host = process.env.API_URL;

    const [showFileExplorer, setShowFileExplorer] = useState(false);
    const [filesSelected, setFilesSelected] = useState([]);
    const [filesOnServer, setFilesOnServer] = useState({});
    
    const [mergeAttributesList, setMergeAttributesList] = useState([]);
    const [selectedMergeAttribute, setSelectedMergeAttribute] = useState('');

    const [serverConfigFiles, setServerConfigFiles] = useState([]);
    const [configSelected, setConfigSelected] = useState(['']);

    const [uploadStatus, setUploadStatus] = useState(UPLOAD_STATUS.INITIAL_LOAD);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [option, setOption] = useState(FILE_EXPLORER_OPTIONS.NONE);
    
    const isCalculateDifference = option === FILE_EXPLORER_OPTIONS.CALC_DIFF;

    const [chartAttributes, setChartAttributes] = useState([]);
    const [chartType, setChartType] = useState('');
    const [selectedChartAttributes, setSelectedChartAttributes] = useState([]);

    useEffect(() => {
        getFiles().then((res) => {
            setFilesOnServer(res);
        })
    }, []);

    useEffect(()=>{
        findConfigFiles(filesOnServer).then((res)=>{
            setServerConfigFiles(['', ...res])
        })
    },[filesOnServer]);

    useEffect(()=>{
        if(uploadStatus === UPLOAD_STATUS.FINISHED){
            getFiles().then((res) => {
                setFilesOnServer(res)
                setUploadStatus(UPLOAD_STATUS.INITIAL_LOAD);
            })
        }
    },[uploadStatus])

    useEffect(() => {
        if (option === FILE_EXPLORER_OPTIONS.CALC_DIFF && filesSelected.length >= 2) {
            getMergeAttributes(filesSelected).then((res) => {
                setMergeAttributesList(res);
            })
        } else if (option === FILE_EXPLORER_OPTIONS.CHARTS && filesSelected.length === 1) {
            getChartAttributes(filesSelected).then((res) => {
                const chartAttributes = []
                for (const [key, value] of Object.entries(res)) {
                    if(value === "float64" || value === "int64"){
                        chartAttributes.push(key)
                    }
                }
                return chartAttributes;
            }).then((res) => setChartAttributes(res));
        }
    }, [option]);

    const handleSubmit = async () => {
        setIsLoading(true);
        setErrorMessage("");
        if(option === FILE_EXPLORER_OPTIONS.CALC_DIFF){
            let diffFile;
            try {
                diffFile = await getDiffCalculation({
                    files: {
                        minuend: filesSelected[0],
                        subtrahend: filesSelected[1]
                    },
                    mergeattr: selectedMergeAttribute,
                    config: configSelected[0]
                });
            } catch (error) {
                setIsLoading(false);
                setErrorMessage(error);
                throw error;
            };
            props.onLoadRemoteMapWithConfig({
                dataUrl: diffFile.url,
                datasetName: diffFile.datasetName,
                data: {}
              });
        } else if(option === FILE_EXPLORER_OPTIONS.CHARTS){
            props.onLoadRemoteMapWithConfig({
                dataUrl: `${host}/api/maps/charts`,
                data: {
                    files: filesSelected,
                    options: {
                        process: "charts",
                        attributes: selectedChartAttributes,
                        scale: 100,
                        chart_type: chartType
                    }
                }
            });
        }
        else{
            props.onLoadRemoteMapWithConfig({
            dataUrl: `${host}/api/maps`,
            data: {
                files: filesSelected.map((f,i) => {
                    return {
                        name: f,
                        config: configSelected[i] ? configSelected[i] : null,
                    };
                })
            }
        })
        }
        
    }

    return (
        isLoading ? 
        <LoadingDialog size={64} message={"Loading..."}/> :
        showFileExplorer ?
            <FileExplorer filesList={filesOnServer}
                files={filesSelected}
                selectFiles={setFilesSelected}
                showFileExplorer={setShowFileExplorer} 
                uploadStatus={uploadStatus}
                setUploadStatus={setUploadStatus}
                />
            :
            (
                <Grid container direction="row">
                    <FileSelection
                        showFileExplorer={setShowFileExplorer}
                        filesSelected={filesSelected}
                        isCalculateDifference={isCalculateDifference}
                        configFiles={serverConfigFiles}
                        configSelected={configSelected}
                        setConfigSelected={setConfigSelected}
                    />
                    {filesSelected.length > 0 &&
                        <Grid item xs={12}>
                            <OptionSelect 
                                selectedOption={option} 
                                setOption={setOption} 
                                filesSelected={filesSelected} />
                        </Grid>
                    }
                    <Grid item xs={12} style={{ paddingBottom: '10px' }}>
                        {filesSelected.length >= 2 && isCalculateDifference ? 
                            <DifferenceSelection
                                // checked={isCalculateDifference}
                            // setChecked={setIsCalculateDifference}
                            mergeAttributes={mergeAttributesList}
                            selectedAttribute={selectedMergeAttribute}
                            setSelectedAttribute={setSelectedMergeAttribute}
                            option={option}
                        /> : null}
                    </Grid>
                    <Grid item xs={12} style={{ paddingBottom: '10px' }}>
                        {filesSelected.length === 1 && option === FILE_EXPLORER_OPTIONS.CHARTS &&
                            <ChartSelect 
                                chartAttributes={chartAttributes}
                                selectedChartAttributes={selectedChartAttributes}
                                setSelectedChartAttributes={setSelectedChartAttributes}
                                chartType={chartType}
                                setChartType={setChartType}
                            />   
                        }
                    </Grid>
                    <Grid style={{ paddingBottom: '10px' }}>
                        <Button variant="contained" onClick={handleSubmit} style={{textTransform: 'none'}}>
                            Load Map
                        </Button>
                        {errorMessage ? <div style={{ color: 'red' }}>{errorMessage}</div> : null}
                    </Grid>
                </Grid>
            )
    );
}

export default LoadFileContainer;